// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"c8a80870","126":"9d1065f6","171":"639ad63b","220":"d7928656","453":"ca7e9547","842":"6a6ee7d8","998":"777e6d37"}[chunkId] + ".chunk.js";
};